import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { SuperAdmin } from 'src/types/client';
import axiosInstance from 'src/utils/axios';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

async function fetchSuperAdmins(): Promise<SuperAdmin[]> {
  const response = await axiosInstance.get<SuperAdmin[]>(api.getSuperAdmins);
  return response.data;
}

const useGetSuperAdminsQuery = (): UseQueryResult<SuperAdmin[]> =>
  useQuery<SuperAdmin[]>({
    queryKey: queryKeys.client.superAdmins(),
    queryFn: fetchSuperAdmins,
    staleTime: ONE_DAY_MS,
    gcTime: ONE_DAY_MS,
  });

export default useGetSuperAdminsQuery;
